export const FETCH_DOWN_LIMIT = 'FETCH_DOWN_LIMIT';
export const FETCH_DOWN_LIMIT_SUCCESS = 'FETCH_DOWN_LIMIT_SUCCESS';

export const fetchDownLimit = (data) => ({
  type: FETCH_DOWN_LIMIT,
  data
})

export const fetchDownLimitSuccess = (data) => ({
  type: FETCH_DOWN_LIMIT_SUCCESS,
  data
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/elog/actions.js
 **/